import { Box, type BoxProps } from "@mui/material";

export default function TableRow({ sx, ...props }: BoxProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          gridColumn: "1 / -1",
          display: "grid",
          gridTemplateColumns: "subgrid",
          border: "none",
          background: "transparent",
          borderBottom: "1px solid",
          borderBottomColor: "divider",
          ":last-child": {
            borderBottomWidth: 0,
          },
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            backgroundColor: "#f8f8f8",
            ...theme.applyStyles("dark", {
              backgroundColor: "#26262a",
            }),
          },
          "&>*": {
            p: 1,
          },
          "&>:first-child": {
            pl: 2,
          },
          "&>:last-child": {
            pr: 2,
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
}
